import { useSearchParams } from "react-router-dom";
import NewPasswordPage from "../NewPasswordPage/NewPasswordPage";
import VerifyEmailPage from "../VerifyEmailPage/VerifyEmailPage";
import NotFoundPage from "../NotFoundPage/NotFoundPage";

export const AuthActionPage = () => {
  const [params] = useSearchParams();
  const mode = params.get("mode");

  if (mode === "resetPassword") {
    return <NewPasswordPage />;
  }

  if (
    mode === "verifyEmail" ||
    mode === "verifyPassword" ||
    mode === "verifyAndChangeEmail" ||
    mode === "recoverEmail" ||
    mode?.startsWith("verify")
  ) {
    return <VerifyEmailPage />;
  }

  return <NotFoundPage />;
};

export default AuthActionPage;
